import React, {Component} from 'react'
import {connect} from "react-redux";
import {Grid} from "react-bootstrap";
import PageTitle from "../../../../common/page-title";
import '../../../products/common/styles.css'
import ArrowButton from "../../../../common/button-arrow";
import {Link} from "react-router-dom";
import PromotionalBannersSearchPanel from './promotional-banners-search-panel';
import {getPromotionalBanners} from '../../../../../actions/promotional_banners'
import withInputChange from "../../../../withInputChange";
import PromotionalBannersList from "./promotional-banner-list";

class PromotionalBanners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayFromDate: '',
      displayToDate: '',
      group: ''
    }
  }

  componentDidMount() {
    this.onApply();
  }

  onApply = () => {
    const {displayFromDate, displayToDate, group} = this.props.fields;
    this.props.dispatch(getPromotionalBanners(displayFromDate, displayToDate, group));
  };

  render() {
    const {
      groupList, handleChange, handleClearFilters, promotional_banners, fetching, fetched, fields
    } = this.props;

    return (
      <Grid bsClass="container" fluid className="products accordion">
        <PageTitle>Promotional Banners</PageTitle>
        <Link to="/admin/promotional_banners/new">
          <div className="mg-bottom-20">
            <ArrowButton
              color="red"
              className="add-promotional-banner"
              submit={false}
              arrow={false}
              permissions={{
                action: 'new',
                subjectClass: 'PromotionalBanner'
              }}
            >
              New Promotional Banner
            </ArrowButton>
          </div>
        </Link>
        <PromotionalBannersSearchPanel
          productValue={fields.product}
          groupValue={fields.group}
          onGroupChange={handleChange('group')}
          groupList={groupList}
          displayFromDateValue={fields.displayFromDate}
          handleDisplayFromDateChange={handleChange('displayFromDate')}
          displayToDateValue={fields.displayToDate}
          handleDisplayToDateChange={handleChange('displayToDate')}
          onApply={this.onApply}
          onClearFilters={handleClearFilters(this.onApply)}
        />
        <PromotionalBannersList
          promotional_banners={promotional_banners}
          fetching={fetching}
          fetched={fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  promotional_banners: state.promotionalBanners.promotional_banners,
  groupList: state.promotionalBanners.groupList,
  fetched: state.promotionalBanners.fetched,
  fetching: state.promotionalBanners.fetching
});

const initialState = {
  displayFromDate: '',
  displayToDate: '',
  group: ''
};

export default connect(mapStateToProps)(withInputChange(initialState)(PromotionalBanners));



// WEBPACK FOOTER //
// ./src/components/admin/promotions/promotional_banners/list/index.jsx